export enum UnleashFlag {
    BrandingUpdatesPhase2 = 'client.experience-2024branding-updates-phase2',
    PhoneNumberConsent = 'client.phone-number-consent',
    LiveServicesFuzzyDice = 'live-services.monthly-availability.fuzzy-dice',
    Braze = 'client.braze',
    MCCCarePediatric = 'client.care-mcchp.pediatric-care-ui',
    ChatTagging = 'client.featured_challenges.enable_chat_tagging',
    CatalogueLandingPage = 'client.catalogue-landing-page',
    FmsUploadEnabled = 'client.fms.upload.enabled',
    HnReleaseMilestone1 = 'client.health-notes.release.milestone-1',
    HnReleaseMilestone2 = 'client.health-notes.release.milestone-2',
    HnReleaseMilestone3 = 'client.health-notes.release.milestone-3'
}
